import React, { useState, useEffect } from 'react';
import { Container, VStack, Heading, Text, Button, Box, Flex } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useActivityResponse } from '../../../hooks/useActivityResponse';
import { TextQuestion } from '../../../components/activities/TextQuestion';

const ND101ACON1AActivityPage: React.FC = () => {
  const navigate = useNavigate();

  const { activity, response, isLoading, saveResponse } = useActivityResponse('post_workshop_NLE');

  const [hasSubmitted, setHasSubmitted] = useState(false);

  useEffect(() => {
    if (!isLoading && response?.response_value) {
      setHasSubmitted(true);
    }
  }, [isLoading, response]);

  const handleResponseChange = async (responseValue: string | null) => {
    if (!responseValue) return;
    try {
      await saveResponse(responseValue);
      setHasSubmitted(true);
    } catch (error) {
      console.error('Failed to save response:', error);
    }
  };

  const handleContinue = () => {
    navigate('/s/chat');
  };

  if (isLoading) {
    return (
      <Container maxW="4xl" py={8}>
        <VStack spacing={6}>
          <Text>Loading...</Text>
        </VStack>
      </Container>
    );
  }

  return (
    <Container maxW="4xl" py={8}>
      <VStack spacing={8} align="stretch">
        <Box>
          <Heading size="lg" mb={4}>
            Time to reflect
          </Heading>
          <Text fontSize="lg" color="gray.600">
            We waited a week on purpose because it gives time to let things settle. New patterns, questions, or connections often surface even without trying.
          </Text>
        </Box>

        {activity && (
          <Box>
            <TextQuestion
              activityKey="post_workshop_NLE"
              required={true}
              placeholder="Share your thoughts here..."
              rows={4}
              onResponseChange={handleResponseChange}
            />
          </Box>
        )}

        {hasSubmitted && (
          <Flex justify="center">
            <Button
              colorScheme="purple"
              size="lg"
              onClick={handleContinue}
            >
              Continue to Chat
            </Button>
          </Flex>
        )}
      </VStack>
    </Container>
  );
};

export default ND101ACON1AActivityPage;
